module.exports = __webpack_public_path__ + "static/drt1-082a28d6a6228b1c3e0802a87ac5de4d.jpg";